<script lang="ts">
</script>

<style lang="scss">
  @use '../../scss/_variables' as *;

  .main-visual {
    width: 100%;
    height: 100vw;
    max-height: 575px;
    background: linear-gradient(
      -45deg,
      #7521da 0%,
      #ff5a5e 20%,
      #7521da 40%,
      #ff5a5e 80%,
      #7521da 100%
    );
    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
    padding: 40px;

    @media screen and (max-width: $screen_width) {
      height: 575px;
    }
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
    &-inner {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      background-image: url(/img/main-vi.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    h1 {
      font-family: $font_jp;
      font-style: normal;
      font-weight: bold;
      font-size: 4.5vmin;
      line-height: 2;

      text-align: center;

      color: #ffffff;
      @media screen and (max-width: $screen_width) {
        font-size: 7.5vmin;
      }
    }
  }
</style>

<article>
  <section class="main-visual">
    <div class="main-visual-inner">
      <h1>
        Spark the Path <br class="br-sp" />
        to Realization
      </h1>
    </div>
  </section>
</article>
